<template>
  <div>
    <el-card>
      <div class="head-group">
        <div class="left-part">
          <div class="rowpart">
            <el-date-picker
              style="width: 120px"
              v-model="year"
              type="year"
              placeholder="选择年"
              format="YYYY"
              value-format="YYYY"
            >
            </el-date-picker>
          </div>
          <SeasonSelect
            class="rowpart"
            @season="this.season = $event"
            v-model="this.season"
          ></SeasonSelect>
        </div>

        <div class="right-part">
          <el-button type="primary" @click="handleAddItem">添加</el-button>
        </div>
      </div>
      <!-- 表格 -->
      <el-table
        :data="
          asItemList.slice((currentPage - 1) * pagesize, currentPage * pagesize)
        "
        border
        style="width: 100%"
        height="600"
        class="diffrow"
        ref="multipleTable"
        @selection-change="handleSelectionChange"
        :default-sort="{ prop: 'id' }"
      >
        <template v-for="column in asItemTable" :key="column.label">
          <el-table-column
            :prop="column.prop"
            :label="column.label"
            width="200"
            :formatter="formatter"
          >
          </el-table-column>
        </template>
        <el-table-column label="操作" width="180">
          <template #default="scope">
            <el-button type="text" @click="handleEdit(scope.$index, scope.row)"
              >查看</el-button
            >
            <el-popconfirm
              title="确认删除?"
              @confirm="handleDelete(scope.$index, scope.row)"
              confirm-button-text="是"
              cancel-button-text="否"
            >
              <template #reference>
                <el-button type="text">删除</el-button>
              </template>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-block">
        <el-pagination
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="asItemList.length"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </el-card>
    <!-- 添加加减分事项模态框 -->
    <el-dialog
      v-model="showable.asItemForm"
      title="添加加减分事项细则"
      width="40%"
    >
      <el-form label-width="120px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="人员姓名">
              <EmployeeSelect
                :depIdArr="[this.departmentId]"
                :type="select"
                v-model="asForm.userId"
              ></EmployeeSelect>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="分数">
              <el-input
                v-model="asForm.score"
                placeholder="注意: 扣分用负数表示"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="年度">
              <el-date-picker
                style="width: 190px"
                v-model="asForm.year"
                type="year"
                placeholder="选择年"
                format="YYYY"
                value-format="YYYY"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="季度">
              <SeasonSelect
                @season="this.asForm.season = $event"
                v-model="this.asForm.season"
              ></SeasonSelect>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="加/减分事由">
              <el-input type="textarea" v-model="asForm.itemDetail"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <div class="upload">
          <el-upload
            ref="uploadAppendix"
            :auto-upload="false"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :before-remove="beforeRemove"
            :data="uploadAppendData"
            :http-request="uploadFile"
            :on-change="getUploadFile"
            :file-list="asForm.appendixList"
            show-file-list
            accept=".pdf, .doc, .docx, .jpg, .jpeg, .png"
          >
            <el-button size="small" type="primary">点击上传附件</el-button>
          </el-upload>
        </div>

        <div class="botton-btn">
          <el-button
            type="primary"
            @click="addAsRecord"
            :disabled="disable.addTaskBtn"
            >确认添加</el-button
          >
          <el-button type="default" @click="doCancel">取消</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import ASItem from "../api/ASItem";
export default ASItem;
</script>

<style scoped lang="scss">
.head-group {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.rowpart {
  margin-right: 10px;
  width: 120px;
}

.left-part {
  display: flex;
  align-items: center;
}

.right-part {
  display: flex;
  align-items: center;
}

.diffrow {
  margin-top: 20px;
}

.pagination-block {
  margin-top: 30px;
}

.upload {
  text-align: center;
  margin-top: 10px;
  margin-bottom: 10px;
}

.botton-btn {
  display: flex;
  justify-content: flex-end;
}
</style>